module.exports = __webpack_public_path__ + "static/img/WeatherApp.7b32d960.webp";